//export const baseUrl = 'https://ct-onlinq.herokuapp.com/';
//export const baseUrl = 'http://localhost:5000/';
export const baseUrl = 'https://ct-onlinq-platform.onrender.com/'; 
//export const baseUrl = 'https:ct-onlinq.iitkgp.ac.in/'